import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Table } from 'react-bootstrap';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Import autoTable separately

import * as XLSX from 'xlsx';
import axios from 'axios';
import '../Default.css';

const BASE_URL = 'https://whapi.infosware-test.in';

function Reports() {
  const [reports, setReports] = useState([]); // State to store reports data

  // Fetch reports data from backend on component mount
  useEffect(() => {
    fetchReports(); // Fetch the reports on initial render
  }, []);

  // Function to fetch reports data from backend
  const fetchReports = () => {
    axios.get(`${BASE_URL}/scans/get-report`)
      .then((response) => {
        console.log(response.data); // Log the data to see if it's correct

        // Remove duplicate reports based on 'created_at'
        // const uniqueReports = response.data.filter((value, index, self) =>
        //   index === self.findIndex((t) => (
        //     t.created_at === value.created_at
        //   ))
        // );

        setReports(response.data); // Update state with unique reports
      })
      .catch((error) => {
        console.error('Error fetching updated reports:', error);
      });
  };

  // const formatDate = (dateString) => {
  //   // Check if the dateString is valid
  //   const date = new Date(dateString);

  //   // Check if the date is invalid (NaN means it's an invalid date)
  //   if (isNaN(date.getTime())) {
  //     return 'Invalid Date';
  //   }

  //   return date.toLocaleDateString('en-US', {
  //     weekday: 'short',
  //     year: 'numeric',
  //     month: 'short',
  //     day: 'numeric',
  //   });
  // };

  // // Function to handle PDF download directly


/// === Helper Function to Format Date from Database ===
const formatDate = (dateString) => {
  if (!dateString) return 'Unknown Date'; // Handle missing date

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return 'Invalid Date'; // Handle invalid date format

  return date.toLocaleDateString('en-US', {
      weekday: 'short', // Example: "Wed"
      year: 'numeric',  // Example: "2024"
      month: 'short',   // Example: "Mar"
      day: 'numeric',   // Example: "6"
  });
};

// Function to refresh the page
const refreshPage = () => {
  window.location.reload();
};

// === Function to Generate and Download PDF ===
const handlePDFDownload = (report) => {
  if (!report || report.length === 0) {
    alert("No report data available!");
    return;
  }
  report = report[0]; // Get the first report data
  const createdAt = report?.created_at || new Date();
  console.log(createdAt)
  const doc = new jsPDF('p', 'mm', 'a4');

  let yPosition = 15; // Adjust Y position for smaller header

  // === HEADER SECTION ===
  doc.setFontSize(17);
  doc.setFont('helvetica', 'bold');
  doc.text('Warehouse Report', 105, yPosition, { align: 'center' }); 
  yPosition += 6;

  const formattedDate = formatDate(createdAt);
  doc.setFontSize(10);
  doc.text(`Date: ${formattedDate}`, 125, yPosition, { align: 'right' });
  yPosition += 10;
  doc.line(50, yPosition, 160, yPosition); 
  yPosition += 7;

  // === TABLE HEADERS (Fixed Color to #1d5892) ===
  const columns = ['Sr No.', 'SKU', 'Item Name', 'Quantity', 'Present Box', 'Total Qnt', 'Compare Box']; 
  const columnWidths = [15, 20, 60, 20, 25, 30, 35]; // Adjusted widths to fit Sr No.
  console.log(report);
  console.log(report.item_data);
  // === REORDER TABLE DATA TO MATCH NEW COLUMN ORDER ===
  const tableData = report.item_data.map((item, index) => [
    index + 1,  // Sr No. (1, 2, 3, ...)
    item.sku || '',
    item.item_name || '',
    item.quantity || '',
    item.present_Box || '',
    item.total_quantity || '',
    item.compare_total_quantity || ''
  ]);

  // === TABLE GENERATION WITH FIXED HEADER COLOR ===
  autoTable(doc, {
    startY: yPosition,
    head: [columns],
    body: tableData,
    styles: { fontSize: 9, cellPadding: 2 },
    headStyles: {
      fillColor: [29, 88, 146], // Set entire header background to #1d5892
      textColor: [255, 255, 255], // White text for contrast
      fontStyle: 'bold'
    },
    columnStyles: {
      0: { cellWidth: columnWidths[0], cellWidth: 'wrap' }, // Sr No.
      1: { cellWidth: columnWidths[1], cellWidth: 'wrap' }, // SKU
      2: { cellWidth: columnWidths[2], cellWidth: 'wrap' }, // Item Name
      3: { cellWidth: columnWidths[3], cellWidth: 'wrap' }, // Quantity
      4: { cellWidth: columnWidths[4], cellWidth: 'wrap' }, // Present Box
      5: { cellWidth: columnWidths[5], cellWidth: 'wrap' }, // Total Qnt
      6: { cellWidth: columnWidths[6], cellWidth: 'wrap' }  // Compare Box
    },
    didParseCell: function (data) {
      if (data.column.index === 6 && data.cell.raw < 0) { // Check if it's the "Compare Box" column and value is negative
        data.cell.styles.textColor = [255, 0, 0]; // Set text color to red
      }
    },
    theme: 'grid'
  });

  // === FOOTER SECTION ===
  doc.setFontSize(8);
  doc.text(`Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`, 10, 285);

  // Save PDF
  const filename = `Audit_Report_${formattedDate.replace(/,/g, '').replace(/\s/g, '_')}.pdf`;
  doc.save(filename);
  refreshPage(); // Refresh the page after saving the PDF
};

// Function to handle Excel download
const handleExcelDownload = (report) => {
  if (!report || report.length === 0) {
    alert("No report data available!");
    return;
  }
  report = report[0]; // Get the first report data

  // === REORDER TABLE DATA TO MATCH NEW COLUMN ORDER ===
  const worksheetData = report.item_data.map((item, index) => ({
    'Sr No.': index + 1,  // Sr No. (1, 2, 3, ...)
    'SKU': item.sku || '',
    'Item Name': item.item_name || '',
    'Quantity': item.quantity || '',
    'Present Box': item.present_Box || '',
    'Total Qnt': item.total_quantity || '',
    'Compare Box': item.compare_total_quantity || ''
  }));

  // Now you can create an Excel file with the worksheetData
  const ws = XLSX.utils.json_to_sheet(worksheetData); // Convert JSON to Excel sheet

  // Apply header styling
  const headerRange = XLSX.utils.decode_range(ws['!ref']);
  for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ c: C, r: 0 });
    const cell = ws[cellAddress];
    if (cell) {
      cell.s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "1D5892" } },
        alignment: { horizontal: "center" }
      };
    }
  }

  // Apply conditional formatting for negative values in 'Compare Box' column
  const compareBoxCol = XLSX.utils.decode_col('G'); // 'G' is the column for 'Compare Box'
  worksheetData.forEach((row, rowIndex) => {
    const cellAddress = XLSX.utils.encode_cell({ c: compareBoxCol, r: rowIndex + 1 }); // +1 to skip header row
    const cell = ws[cellAddress];
    if (cell && cell.v < 0) {
      cell.s = { font: { color: { rgb: "FF0000" } } }; // Set font color to red
    }
  });

  // Apply border styling to all cells
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];
      if (cell) {
        cell.s = cell.s || {};
        cell.s.border = {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } }
        };
      }
    }
  }

  const wb = XLSX.utils.book_new(); // Create a new workbook
  XLSX.utils.book_append_sheet(wb, ws, 'Report'); // Append the sheet to the workbook

  // Generate and download the Excel file
  const reportDate = formatDate(report?.created_at || new Date());
  const currentDate = new Date();
  const realTime = currentDate.toLocaleTimeString('en-US', { hour: '2-digit', hour12: true }).replace(/:/g, '-');
  const filename = `Audit_Report_${reportDate}_${realTime}.xlsx`;

  // Save the file
  XLSX.writeFile(wb, filename);
  refreshPage(); // Refresh the page after saving the Excel file
};

  // Function to handle dropdown item click for PDF or Excel
  const handleDownload = (report, downloadType) => {
    const confirmMessage = `Do you want to download the report as ${downloadType === 'pdf' ? 'PDF' : 'Excel'}?`;
    const isConfirmed = window.confirm(confirmMessage);

    if (isConfirmed) {
      if (downloadType === 'pdf') {
        handlePDFDownload([report]); // Directly download the PDF
      } else if (downloadType === 'excel') {
        handleExcelDownload([report]); // Directly download the Excel file
      }
    }
  };

  // Function to render the content
  const renderContent = () => {
    return (
      <div className='p-4'>
        <div className="d-flex justify-content-between align-reports-center mt-4 mb-4">
          <h3>Report List</h3>
        </div>
        <Table striped bordered hover responsive className='mb-5 mt-2'>
          <thead>
            <tr>
              <th>Sr.no</th>
              <th>Date</th>
              <th>Report Name</th>
            </tr>
          </thead>
          <tbody>
            {reports.slice().reverse().map((item, index) => (
              <tr key={item.report_id}>
                <td>{index + 1}</td>
                <td>{formatDate(item.created_at)}</td>
                <td>Inventory Report {formatDate(item.created_at)}</td>
                <td>
                  <div className="d-flex justify-content-end align-reports-center gap-4 p-1">
                    <Dropdown>
                      <Dropdown.Toggle variant="primary">Download</Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item className='text-success' onClick={() => handleDownload(item, 'excel')}>
                          Excel
                        </Dropdown.Item>
                        <Dropdown.Item className='text-warning' onClick={() => handleDownload(item, 'pdf')}>
                          PDF
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <div className="reports">
      {renderContent()}
    </div>
  );
}

export default Reports;
